import { render, staticRenderFns } from "./ViewContactComponent.vue?vue&type=template&id=0b04d6e4"
import script from "./ViewContactComponent.vue?vue&type=script&lang=js"
export * from "./ViewContactComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports